import React from 'react'

/**
 * Shared shell for every chart: title, optional subtitle, and a single place
 * where the empty state is worded.
 */
const ChartCard = ({ title, subtitle, isEmpty, emptyMessage = 'No activity in the selected date range.', children }) => (
    <div className="incident-reports-chart-surface">
        <div className="incident-reports-chart">
            <div className="viz-card-heading">
                <h5>{title}</h5>
                {subtitle && <p className="viz-card-subtitle">{subtitle}</p>}
            </div>
            {isEmpty ? <div className="no-data">{emptyMessage}</div> : children}
        </div>
    </div>
)

export default ChartCard
